import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private oidcSecurityService: OidcSecurityService) {}

  canActivate(): Observable<boolean> {
    if (!environment.securityEnabled) {
      return of(true);
    }
    
     return this.oidcSecurityService.checkAuth().pipe(
      map(({ isAuthenticated }) => {
        if (!isAuthenticated) {
          this.oidcSecurityService.authorize(); // redirige al login OIDC
          return false;
        }
        return true;
      })
    );
  } 
}
